import { DEVICE_PLATFORM } from 'utils/device/constants'

/**
 * Determine the mobile operating system.
 * This export function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 * @see http://stackoverflow.com/a/9039885/177710
 * @returns {string}
 */
export function getPlatformDeviceUtil (userAgent) {
  if (SERVER && !userAgent) {
    return DEVICE_PLATFORM.UNKNOWN
  }

  if (BROWSER && !userAgent) {
    userAgent = (
      navigator.userAgent ||
      navigator.vendor ||
      window.opera
    )
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/gi.test(userAgent)) {
    return DEVICE_PLATFORM.WINDOWS_PHONE
  }

  if (/android/i.test(userAgent)) {
    return DEVICE_PLATFORM.ANDROID
  }

  // iOS & Mac detection
  let MSStream
  if (BROWSER) {
    MSStream = window.MSStream
  }

  if (/Apple|Mac|iPad|iPhone|iPod/gi.test(userAgent) && !MSStream) {
    return DEVICE_PLATFORM.APPLE
  }

  return DEVICE_PLATFORM.UNKNOWN
}

export function isApplePhoneOrTablePlatformUtil (userAgent) {
  return /iPhone|iPad/gi.test(userAgent) && !/Macintosh/gi.test(userAgent)
}

export function isAndroidPhoneOrTabletPlatformUtil (userAgent) {
  return /Android/gi.test(userAgent) && /Mobile/gi.test(userAgent)
}

export function isApplePlatformUtil (userAgent) {
  return getPlatformDeviceUtil(userAgent) === DEVICE_PLATFORM.APPLE
}

export function isAndroidPlatformUtil (userAgent) {
  return getPlatformDeviceUtil(userAgent) === DEVICE_PLATFORM.ANDROID
}

export function isAndroidDevicePlatformUtil (userAgent) {
  return getPlatformDeviceUtil(userAgent) === DEVICE_PLATFORM.ANDROID
}

export function isAppleOrAndroidPlatformUtil (userAgent) {
  return (
    isApplePlatformUtil(userAgent) ||
    isAndroidDevicePlatformUtil(userAgent)
  )
}

export function isAppleOrAndroidPhoneOrTabletPlatformUtil (userAgent) {
  return (
    isApplePhoneOrTablePlatformUtil(userAgent) ||
    isAndroidPhoneOrTabletPlatformUtil(userAgent)
  )
}
